import { render, staticRenderFns } from "./InvitePerson.vue?vue&type=template&id=c6a83d8c&scoped=true"
import script from "./InvitePerson.vue?vue&type=script&lang=js"
export * from "./InvitePerson.vue?vue&type=script&lang=js"
import style0 from "./InvitePerson.vue?vue&type=style&index=0&id=c6a83d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a83d8c",
  null
  
)

export default component.exports